// extracted by mini-css-extract-plugin
export default {"main":"styles_main__JmSeI","blue1":"styles_blue1__SBABi","blue2":"styles_blue2__aW6Cl","blue3":"styles_blue3__20Rry","white":"styles_white__FkYus","grey":"styles_grey__fmcQH"};